import { useEffect, useState } from 'react';
import styles from './FAQSearchBar.module.scss';
import * as vp from 'vopay';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const { Button } = vp;

type FAQSearchBarProps = {
  position: string;
  borderColor: string;
  searchedValue: string;
};

const FAQSearchBar: React.FC<FAQSearchBarProps> = ({ position, borderColor, searchedValue }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const history = useHistory();
  const { t } = useTranslation('translations', { keyPrefix: 'LearningCentre.FAQ' });

  const formStyle = {
    justifyContent: position,
  };

  const inputStyle = {
    border: `2px solid ${borderColor}`,
  };

  useEffect(() => {
    if (searchedValue) {
      setSearchTerm(searchedValue);
    }
  }, []);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    history.push(`/faq-search-result?keyword=${searchTerm}`);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  return (
    <form onSubmit={handleSearch} className={styles.searchContainer__innerWrapper} style={formStyle}>
      <input
        className={styles.searchInput}
        type="text"
        placeholder={t('searchInputPlaceholder')}
        value={searchTerm}
        onChange={handleInputChange}
        style={inputStyle}
      />
      <Button id="search-button" label={t('searchButton')} type="submit" />
    </form>
  );
};

export default FAQSearchBar;
